import { useEffect, useState } from 'react'
import styles from './StatisticView.module.css'
import bg from './image/bg_run.png'
import runningHttpClient from '../../../../axios'
import { StatisticTrainingTypeDomain } from '../../../../models/commonModels'
export const StatisticItem = ({bgImage=undefined, activity}:{bgImage?:string|undefined,activity:string}) =>{
    const [distance,setDistance] = useState(0)
    const [count,setCount] = useState(0)

    useEffect(()=>{
        fetchData()
    },[])

    async function fetchData() {
    try {
        const response = await runningHttpClient.get<StatisticTrainingTypeDomain>('/api/v1/statistics/trainingRun', {params:{activity:activity}});
        setDistance(response.data.distance)
        setCount(response.data.count)
    } catch (error) {
        console.error('Ошибка:', error);
    }
}
    return(
        <div className={styles.statisticView_item_container}>
                <div className={styles.statisticView_item_body}>
                    <div className={styles.statisticView_item_column}>
                        <div className={styles.statisticView_item_h1}>
                            {distance.toLocaleString('ru')}
                        </div>
                        <div>
                            {activity!="SWIMMING"?"КМ":"М"}
                        </div>
                    </div>
                    <div className={styles.statisticView_item_column}>
                        <div className={styles.statisticView_item_h1}>
                            {count}
                        </div>
                        <div>
                            ТРЕНИРОВКИ
                        </div>
                    </div>
                </div>
                {bgImage&&<img src={bgImage} className={styles.statisticView_item_bg} style={{width:"100%", height:"auto", objectFit: "cover"}}/>}
        </div>
    )
}